import { create } from 'apisauce'
const apiClient = create({
    timeout: 30000,
    baseURL: 'https://fanikiafrica.org/betterme/public/api'

})

export default apiClient